import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import useControlPanel from "src/hooks/useControlPanel";
import useDebounce from "src/hooks/useDebounce";
import Pagination from "src/components/Pagination/Pagination";
import ControlPanelSystem from "src/components/controlPanelSystem/ControlPanelSystem";
import PermissionControlPanel from "../../components/ControlPanel/PermissionControlPanel";
import PermissionTable from "../../components/Table/PermissionTable";
import { getPermissions } from "src/apis/System/permission.api";
import { path } from "src/constants/path";

const initPermissionData = {
  list: [],
  total_record: 0,
};

const titlePage = "Permissions";

const Permissions = () => {
  const {
    page,
    searchKey,
    numberPage,
    setNumberPage,
    limit,
    setLimit,
    status,
    setStatus,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    handleInputChange,
    handleChangePage,
  } = useControlPanel();

  const [permissionData, setPermissionData] = useState(initPermissionData);
  let search = useDebounce(searchKey, 500);

  useEffect(() => {
    const query = {
      page: numberPage,
      limit,
      searchKey: search,
      startDate,
      endDate,
      status,
    };

    getPermissions(query, (result) => {
      setPermissionData({ ...result });
    });
  }, [endDate, limit, numberPage, page, search, startDate, status]);

  return (
    <div>
      <div className="page-header">
        <h2>{titlePage}</h2>
      </div>

      <PermissionControlPanel>
        <ControlPanelSystem
          searchKey={searchKey}
          handleInputChange={(e) => handleInputChange(e)}
          limit={limit}
          setLimit={setLimit}
          setNumberPage={setNumberPage}
          status={status}
          setStatus={setStatus}
          setStartDate={setStartDate}
          setEndDate={setEndDate}
        />
      </PermissionControlPanel>

      <PermissionTable data={permissionData.list} />

      <Pagination
        pathname={path.systemPermission}
        page={numberPage}
        handleChangePage={(page) => handleChangePage(page)}
        limit={limit}
        pageSize={permissionData.total_record}
      />
    </div>
  );
};

export default Permissions;
